<template>
    <div>
        <div class="d-flex justify-content-between">
            <div class="p-2 bd-highlight mt-auto mb-auto">
                <h2 style="font-weight: 600; font-size: 18px; margin-bottom: 0;">Penerimaan QR</h2>
            </div>
            <div class="p-2 bd-highlight" style="width: 150px;">
                <div class="row"  style="margin-left: 30px;"> 
                     <div class="col-12 mt-auto mb-auto" style="margin-r">
                        Saldo QR : <span >{{ saldoQr != null ? numberWithCommas(saldoQr) : 'Loading...' }}</span>
                    </div>
                </div>
            </div>
        </div>


        <qrReceiptFromMD
            class="mt-4"
        ></qrReceiptFromMD>

    </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import moment from 'moment';
import qrReceiptFromMD from './children/qrReceiptFromMD.vue'

export default {
    metaInfo : {
        title : 'QR Issue'
    },
    components : {
        Multiselect,
        qrReceiptFromMD
    },
    data () {
        let startDate = moment().startOf('month').format("MM-DD-Y");
        let currentDate = moment().format("MM-DD-Y");
        return {
            rangePickr: {
                mode: 'range',
                dateFormat: "m-d-Y",
                altInput: true,
                altInputClass: 'form-control input bg-white h-47px',
                altFormat : 'm-d-Y'
            },
            selected : {
                date : `${startDate} to ${currentDate}`
            },
            saldoQr : null,
        }
    },
    beforeMount () {
        document.getElementById('content').style.background = '#F8F8F8';
    },
    beforeDestroy () {
        document.getElementById('content').style.background = '';
    },
    mounted () {
        this.fetchData();
    },
    methods : {
        fetchData() {
            this.$http.get(`/api/qrs/highlight/dealer`)
            .then((resp)=>{
                this.saldoQr = resp.data.data.qty_after
            })
            .catch((err)=>{console.log(err)})
        },
    },
}
</script>

<style>
    .mpm-button {
        background-color :#F36F21 !important;
        color : white;
        height: 47px;
    }

    .mpm-button-outline {
        background-color :white !important;
        color : #F36F21;
        height: 47px;
    }

    .h-47px {
        height: 47px;
    }
</style>